module.exports = __webpack_public_path__ + "img/162.65be6b5b.png";